export const geographicalCoverageTextContent = {
  headingText: "Geographical Coverage",
  imageSrc: "/assets/stock-img/geographical_coverage_img.webp",
};
